import { useCallback, useEffect, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';

// A "Columns" menu that lets an admin hide optional columns on a ResponsiveTable. The hidden
// set is remembered per browser under `storageKey`.
//
//   const { hidden, toggle } = useHiddenColumns('rv:car_rental:adminBookingsCols', ['owner']);
//   <ColumnToggle options={OPT_COLS} hidden={hidden} onToggle={toggle} />
//   <ResponsiveTable columns={cols.filter((c) => !hidden.has(c.key))} … />
export function useHiddenColumns(storageKey, defaultHidden = []) {
  const [hidden, setHidden] = useState(() => {
    try {
      const raw = window.localStorage.getItem(storageKey);
      if (raw) return new Set(JSON.parse(raw));
    } catch { /* private mode / blocked - fall through to the default */ }
    return new Set(defaultHidden);
  });

  useEffect(() => {
    try { window.localStorage.setItem(storageKey, JSON.stringify([...hidden])); } catch { /* ignore */ }
  }, [storageKey, hidden]);

  const toggle = useCallback((key) => {
    setHidden((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  }, []);

  return { hidden, toggle };
}

export default function ColumnToggle({ options, hidden, onToggle, label = 'Columns' }) {
  return (
    <Dropdown autoClose="outside">
      <Dropdown.Toggle size="sm" variant="outline-secondary">{label}</Dropdown.Toggle>
      <Dropdown.Menu renderOnMount popperConfig={{ strategy: 'fixed' }} className="p-2">
        {options.map((o) => (
          <Form.Check
            key={o.key}
            type="checkbox"
            id={`coltoggle-${o.key}`}
            label={o.label}
            checked={!hidden.has(o.key)}
            onChange={() => onToggle(o.key)}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
